import axios from "axios";
import { ACCOUNT_VALIDATION_STATUS } from "../../../actions/taxFreeSavingsAccount/types";

import { setAccountValidationStatus } from "../../../actions/taxFreeSavingsAccount/paymentDetails";

import {
    getIncludeCdv,
    getIncludeAvs,
    getPaymentAuthorizationChecked,
    getBankSupportedForTFSA,
    getAvsPayload,
    getCdvPayload,
} from "../../../selectors/taxFreeSavingsAccount/paymentDetails";
import { setRequestId } from "../../../actions/taxFreeSavingsAccount/sessionCamVariables";

export const performAccountValidation = store => {
    const state = store.getState();

    // skip validation if payment authorization checked
    if (getPaymentAuthorizationChecked(state)) {
        return;
    }

    // Supported banks go to AVS if toggled in ContentStack
    if(getBankSupportedForTFSA(state) && getIncludeAvs(state)) {
        performAvsService(store);
        return;
    }

    // In all other scenarios go to CDV if it is toggled in ContentStack
    if(getIncludeCdv(state)) {
        performCdvService(store);
        return;
    }

    // If there is no verification setting as successful
    store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.PASSED));

    return;
};

export const performAvsService = store => {
    (async () => {
        // Set status as Pending
        store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.PENDING));
        const state = store.getState();

        const avsPayload = getAvsPayload(state);
        const avsResponse = await submitAvs(avsPayload);

        if (avsResponse && avsResponse.status === 200 && avsResponse.data) {
            // If request was successful
            if(avsResponse.data.success) {
                // if AVS passed
                store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.PASSED));
            } else{
                // if AVS failed
                store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.FAILED));
            }
        } else {
            // If request was unsuccessful
            store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.ERROR));
        }

         
        if (avsResponse && 'data' in avsResponse && 'requestId' in avsResponse.data) {
            store.dispatch(setRequestId(avsResponse.data.requestId));
        }
    })();

    return;

};

export const performCdvService = store => {
    (async () => {
        // Set status as Pending
        store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.PENDING));
        const state = store.getState();

        const cdvPayload = getCdvPayload(state);
        const cdvResponse = await submitCdv(cdvPayload);

        if (cdvResponse && cdvResponse.status === 200 && cdvResponse.data) {
            // If request was successful
            if(cdvResponse.data.success) {
                // if CDV passed
                store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.PASSED));
            } else{
                // if CDV failed
                store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.FAILED));
            }
        } else {
            // If request was unsuccessful
            store.dispatch(setAccountValidationStatus(ACCOUNT_VALIDATION_STATUS.ERROR));
        }

         
        if (cdvResponse && 'data' in cdvResponse && 'requestId' in cdvResponse.data) {
            store.dispatch(setRequestId(cdvResponse.data.requestId));
        }
    })();

    return;
}

export const submitCdv = async payload => {
    try {
        const response = await axios.post('/om-api/check-digit-validation', payload, { headers: { 'Content-Type': 'application/json' } });
        return response;
    } catch (error) {
        return null;
    }
};

export const submitAvs = async payload => {
    try {
        const response = await axios.post('/om-api/account-verification-service', payload, { headers: { 'Content-Type': 'application/json' } });
        return response;
    } catch (error) {
        return null;
    }
};
